import script from "./ExamTestQuestionBodyMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamTestQuestionBodyMobile.vue?vue&type=script&setup=true&lang=ts"

import "./ExamTestQuestionBodyMobile.vue?vue&type=style&index=0&id=0cee3ca6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cee3ca6"]])

export default __exports__